import { createRequestFactory } from "@/lib/request-factory";
import {
  ClientPaymentMethodDocument,
  type ClientPaymentMethodQuery,
  type ClientPaymentMethodQueryVariables,
} from "@/__generated__/graphql";
import { useAuthState } from "@/store/auth";
import type { UserPaymentMethod } from "@/types/users";

type Response = {
  paymentMethod: UserPaymentMethod | null;
};

export const useClientPaymentMethodStore = createRequestFactory<
  ClientPaymentMethodQuery,
  Response,
  ClientPaymentMethodQueryVariables
>({
  method: "query",
  graphqlDocument: ClientPaymentMethodDocument,
  fetchPolicy: "network-only",
  transformFunction: (res) => {
    return {
      paymentMethod: res.client?.paymentMethod ?? null,
    };
  },
  onFetchSuccess: ({ paymentMethod }) => {
    const { setPaymentMethod } = useAuthState.getState();
    setPaymentMethod(paymentMethod);
  },
});
